module.exports = "https://www.gc-qa.gnp.com.mx/66c54c4f4d88235ac37f9362e640c1d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/retenciones/03.png
// module id = 1061
// module chunks = 0 1